(function () {
  'use strict';

  if (!location.pathname.startsWith('/a/subscriptions/manage/')) return;

  var PROXY_URL = 'https://grns-insights-hub.vercel.app/api/seal-proxy';

  var ADDONS = [
    {
      key: 'sachet_natural',
      product_id: '7774652006481',
      variant_id: '59228793405521',
      title: 'Travel Sachets — Natural',
      sku: 'GRN-SACHET',
      price: 7.99,
      comparePrice: 19.99,
      quantity: 1,
      label: 'Natural Sachets',
      detail: '2× pack · one time addition, next renewal',
      image: 'https://cdn.shopify.com/s/files/1/0572/1253/4865/files/gempages_489095260442461323-54515ca1-fbd7-4c5f-bfe6-7f048251e639.webp?v=1747866450'
    },
    {
      key: 'sachet_mango',
      product_id: '7774652006481',
      variant_id: '59228793438289',
      title: 'Travel Sachets — Mango',
      sku: 'GRN-SACHET-2',
      price: 7.99,
      comparePrice: 19.99,
      quantity: 1,
      label: 'Mango Sachets',
      detail: '2× pack · one time addition, next renewal',
      image: 'https://cdn.shopify.com/s/files/1/0572/1253/4865/files/gempages_489095260442461323-54515ca1-fbd7-4c5f-bfe6-7f048251e639.webp?v=1747866450'
    },
    {
      key: 'bottle',
      product_id: '7774651711569',
      variant_id: '42398899601489',
      title: 'Premium Glass Bottle',
      sku: 'GRN-BOTTLE',
      price: 19.99,
      comparePrice: 29.99,
      quantity: 1,
      label: 'Glass Bottle',
      detail: '500ml · one time addition, next renewal',
      image: 'https://cdn.shopify.com/s/files/1/0572/1253/4865/files/GRNS_169_ads_1080_x_1080_px_29.webp?v=1771737940'
    }
  ];

  function getSubscriptionId() {
    var parts = location.pathname.split('/');
    var idx = parts.indexOf('manage');
    if (idx === -1 || !parts[idx + 1]) return null;
    return parseInt(parts[idx + 1], 36);
  }

  function buildCard(addon) {
    var card = document.createElement('div');
    card.className = 'grns-addon-card';
    card.innerHTML =
      '<img class="grns-addon-card__img" src="' + addon.image + '" alt="' + addon.label + '">' +
      '<div class="grns-addon-card__info">' +
        '<div class="grns-addon-card__price">' +
          '$' + addon.price.toFixed(2) +
          '<span class="grns-addon-card__compare">$' + addon.comparePrice.toFixed(2) + '</span>' +
        '</div>' +
        '<div class="grns-addon-card__label">' + addon.label + ' <span class="grns-addon-card__members">(Members Pricing)</span></div>' +
        '<div class="grns-addon-card__detail">' + addon.detail + '</div>' +
      '</div>' +
      '<button class="grns-addon-card__btn" type="button">Add</button>';

    var btn = card.querySelector('.grns-addon-card__btn');
    btn.addEventListener('click', function () {
      var subId = getSubscriptionId();
      if (!subId) return;

      btn.disabled = true;
      btn.textContent = 'Adding';
      btn.classList.add('grns-addon-card__btn--loading');

      fetch(PROXY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: subId,
          action: 'add_items',
          add_items: [{
            product_id: addon.product_id,
            variant_id: addon.variant_id,
            quantity: addon.quantity,
            title: addon.title,
            sku: addon.sku,
            price: addon.price,
            taxable: 1,
            requires_shipping: 0,
            one_time: 1,
            properties: []
          }]
        })
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.error || data.errors) {
          btn.disabled = false;
          btn.textContent = 'Add';
          btn.classList.remove('grns-addon-card__btn--loading');
          console.error('GRNS addon error:', data);
          return;
        }
        btn.classList.remove('grns-addon-card__btn--loading');
        btn.textContent = 'Added ✓';
        btn.style.background = '#4a7a3a';
        card.classList.add('grns-addon-card--added');
        setTimeout(function () {
          sessionStorage.setItem('grns_portal_reloading', '1');
          location.reload();
        }, 250);
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = 'Add';
        btn.classList.remove('grns-addon-card__btn--loading');
        console.error('GRNS addon error:', err);
      });
    });

    return card;
  }

  function styleOneTimeBadges() {
    var candidates = document.querySelectorAll('span, div, p, label, small');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.children.length === 0 && el.textContent.trim() === 'One-time purchase') {
        el.style.setProperty('background', '#e8f5e2', 'important');
        el.style.setProperty('color', '#2d6a1f', 'important');
        el.style.setProperty('border-color', '#c8e6c0', 'important');
      }
    }
  }

  function inject() {
    // Clear loading overlay now that portal has rendered
    document.documentElement.classList.remove('grns-portal-loading');

    if (document.querySelector('.grns-addon-section')) return;
    if (!getSubscriptionId()) return;

    var section = document.createElement('div');
    section.className = 'grns-addon-section';

    var heading = document.createElement('p');
    heading.className = 'grns-addon-section__heading';
    heading.textContent = 'Add to next renewal';
    section.appendChild(heading);

    var grid = document.createElement('div');
    grid.className = 'grns-addon-grid';
    ADDONS.forEach(function (addon) {
      grid.appendChild(buildCard(addon));
    });
    section.appendChild(grid);

    // Desktop: inject above discount code box in right panel
    section.classList.add('grns-addon-section--desktop');
    var discountBox = document.querySelector('[data-discount-code-container]');
    if (discountBox && discountBox.parentNode) {
      discountBox.parentNode.insertBefore(section, discountBox);
    } else {
      var fallback =
        document.querySelector('.seal-oneThird') ||
        document.querySelector('main') ||
        document.body;
      fallback.appendChild(section);
    }

    // Mobile: inject above billing schedule in left panel
    var mobileSection = section.cloneNode(true);
    mobileSection.classList.remove('grns-addon-section--desktop');
    mobileSection.classList.add('grns-addon-section--mobile');

    // Re-attach click handlers to cloned buttons — mirror state back to visible mobile button
    var clonedBtns = mobileSection.querySelectorAll('.grns-addon-card__btn');
    var originalBtns = section.querySelectorAll('.grns-addon-card__btn');
    clonedBtns.forEach(function(btn, i) {
      btn.addEventListener('click', function() {
        var origBtn = originalBtns[i];
        btn.disabled = true;
        btn.textContent = 'Adding';
        btn.classList.add('grns-addon-card__btn--loading');

        origBtn.click();

        var observer = new MutationObserver(function() {
          if (origBtn.textContent === 'Added ✓') {
            btn.classList.remove('grns-addon-card__btn--loading');
            btn.textContent = 'Added ✓';
            btn.style.background = '#4a7a3a';
            btn.closest('.grns-addon-card').classList.add('grns-addon-card--added');
            observer.disconnect();
          } else if (!origBtn.disabled) {
            btn.disabled = false;
            btn.textContent = 'Add';
            btn.classList.remove('grns-addon-card__btn--loading');
            observer.disconnect();
          }
        });
        observer.observe(origBtn, { attributes: true, childList: true, characterData: true, subtree: true });
      });
    });

    var billingSection =
      document.querySelector('[data-billing-schedule]') ||
      document.querySelector('.seal-billing-schedule') ||
      (function() {
        var headings = document.querySelectorAll('h2, h3, h4, p, div');
        for (var i = 0; i < headings.length; i++) {
          if (headings[i].textContent.trim() === 'Billing schedule') {
            return headings[i].closest('[class*="seal-"]') || headings[i].parentNode;
          }
        }
        return null;
      })();

    if (billingSection && billingSection.parentNode) {
      billingSection.parentNode.insertBefore(mobileSection, billingSection);
    }

    // Style Seal's yellow one-time purchase badges green
    styleOneTimeBadges();
    setTimeout(styleOneTimeBadges, 500);
    setTimeout(styleOneTimeBadges, 1500);
  }

  // Seal fires this event when portal is fully rendered
  document.addEventListener('sealsubs_portal:loaded', inject);

  // Fallback in case event already fired or doesn't fire
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(inject, 800); });
  } else {
    setTimeout(inject, 800);
  }
})();
